/**
 * ステップIDから日本語名を取得する関数
 * @param stepId ステップID
 * @returns 日本語名（表示しない場合はnull）
 */
export const getStepNameFromId = (stepId: string): string | null => {
  // mappingステップの判定（mapping_で始まる場合は非表示にする）
  if (stepId.toLowerCase().startsWith("mapping_")) {
    return null; // 表示しない
  }

  switch (stepId) {
    case "initialize-step":
      return null; // 表示しない
    case "document-read":
      return "ドキュメント取得";
    case "knowledge-read":
      return "ナレッジ取得";
    case "query":
      return "情報取得";
    case "edit":
      return "ドキュメント編集";
    case "skip-edit":
      return null; // editMode=OFF 時は非表示
    case "think":
      return "思考";
    case "reflect":
      return "回答評価";
    // Phase B: ドキュメント生成ステータス
    case "generating-document":
      return "ドキュメント生成中";
    case "reviewing-document":
      return "ドキュメントレビュー";
    case "editing-document":
      return "ドキュメント編集中";
    case "document-approved":
      return "ドキュメント承認済み";
    // updateDocumentWorkflow: ドキュメント編集チャット
    case "generate-content":
      return "ドキュメント生成";
    case "analyze-diff":
      return "差分分析";
    case "validate-structure":
      return "構造バリデーション";
    case "reflect-structure":
      return "構造修正";
    case "revalidate-structure":
      return "構造再検証";
    default:
      return null;
  }
};

/**
 * ツール名からユーザー向け日本語表示名を取得する関数
 * @param toolName ツール名
 * @returns 日本語表示名（非表示にする場合はnull）
 */
export const getToolDisplayName = (toolName: string): string | null => {
  switch (toolName) {
    case "bingSearchTool":
      return "Web検索";
    case "updateDocumentTool":
      return "ドキュメント編集";
    case "updateWorkingMemory":
      return null;
    default:
      return null;
  }
};
